import {
    patchFormEditorFormFieldsUpdateReducer,
} from '../../slices/gq-admin/form-editor';

export const gqAdminFormEditorReducers = {
    patchFormEditorFormFieldsUpdate: patchFormEditorFormFieldsUpdateReducer,
};
